import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import { getDDMMMYYYYDate } from 'helpers/utils';

import styles from './MarketingTermsAndConditionsPage.module.css';

const MarketingTermsAndConditionsPage = (props) => {
    return (
        <PromoPageContainer bgColor="eggshell03" hasTopPadding>
            {props.headline1Title && <HeadingSection title={props.headline1Title} text={props.headline1Text} />}
            <ColoredSectionContainer>
                {props.document && Array.isArray(props.document) && props.document.length > 0 && (
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>{props.documentTitle}</th>
                                <th>{props.validTitle}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.document.map((doc) => (
                                <tr key={doc.id}>
                                    <td>
                                        <a href={doc.link ? doc.link : '#'} target="_blank" rel="noopener noreferrer">
                                            {doc.title}
                                        </a>
                                    </td>
                                    <td>{doc.valid_date ? getDDMMMYYYYDate(doc.valid_date, props.lang) : '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </ColoredSectionContainer>
        </PromoPageContainer>
    );
};

const mapStateToProps = (state) => {
    return {
        headline1Title: state.extra?.strapiApi?.headline1?.title,
        headline1Text: state.extra?.strapiApi?.headline1?.text,

        documentTitle: state.extra?.strapiApi?.document_title,
        validTitle: state.extra?.strapiApi?.valid_title,

        document: state.extra?.strapiApi?.document,

        lang: state.extra.noAuthFooter?.language?.lang,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(MarketingTermsAndConditionsPage));
